import { Routes } from '@angular/router';
import { permissionGuard } from '@core/guards';

export const driverRoutes: Routes = [
  {
    path: 'drivers',
    loadComponent: () =>
      import('@feature/driver/driver.component').then(m => m.DriverComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [permissionGuard('DispatcherDriversView')],
        loadComponent: () =>
          import('@feature/driver/drivers/drivers.component').then(
            m => m.DriversComponent
          ),
      },
      {
        path: 'alerts',
        canActivate: [permissionGuard('DispatcherDriversAlertView')],
        loadComponent: () =>
          import('@feature/driver/driver-alerts/driver-alerts.component').then(
            m => m.DriverAlertsComponent
          ),
      },
      {
        path: 'vehicles',
        canActivate: [permissionGuard('DispatcherVehiclesView')],
        loadComponent: () =>
          import('@feature/driver/vehicles/vehicles.component').then(
            m => m.VehiclesComponent
          ),
      },
    ],
  },
];
